import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { View } from 'foundations-components/components/View';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { SingleSkeletonLoader } from '../components/SingleSkeletonLoader';
import { useBestRecurringTermDiscountedPriceDueUponPurchase } from '../hooks/usePurchaseOptions';
import { jsx as _jsx } from "react/jsx-runtime";
export const PriceByProductApiName = ({
  productApiName,
  showPerMonth = false
}) => {
  const priceQuery = useBestRecurringTermDiscountedPriceDueUponPurchase({
    productApiName
  });
  if (priceQuery.loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 40,
      width: 175
    });
  }
  if (priceQuery.error || !priceQuery.data.price || !priceQuery.data.currencyCode) {
    return /*#__PURE__*/_jsx(View, {
      blockSize: "40px",
      inlineSize: "175px"
    });
  }
  if (showPerMonth) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "priceComponents.pricePerMonth",
      options: {
        price: /*#__PURE__*/_jsx(PriceDisplay, {
          price: priceQuery.data.price,
          currencyCode: priceQuery.data.currencyCode
        })
      }
    });
  }
  return /*#__PURE__*/_jsx(PriceDisplay, {
    price: priceQuery.data.price,
    currencyCode: priceQuery.data.currencyCode
  });
};